// import { useCallback, useEffect, useMemo, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'

// // antd
// import {
//     Col,
//     Form,
//     Modal,
//     Row,
//     Typography,
//     Select,
//     DatePicker,
//     message,
//     theme,
//     Spin,
// } from 'antd'

// // redux
// import { timesheetApi } from './redux/apis'
// import { reportsActions } from './redux/slice'

// // slices
// import { projectsList, projectsState } from '../../projects/projects.slice'
// import { teamListGet, teamState } from '../../team/team.slice'

// // components
// import Button from '../../../components/button/button'
// import EditReport from './EditReport'

// // helpers
// import { unique } from '../../../helpers/uniqueArray'

// import dayjs from 'dayjs'
// import { useNavigate } from 'react-router-dom'
// import { PRIVATE_ROUTES } from '../../../routes'
// import { debounce } from 'lodash'

// // slices

// const DownloadPopUp = ({
//     previewModal,
//     onCancel,
//     modalTitle,
//     loadingButton,
//     selectedProject,
//     selectAssignees
// }) => {
//     const { Title } = Typography

//     const { useToken } = theme
//     const { token } = useToken()

//     const { RangePicker } = DatePicker

//     const initialValues = useMemo(() => {
//         return {
//             projects: [],
//             assignee: [],
//             rangePicker: [],
//             start: '',
//             end: '',
//         }
//     }, [])

//     const dispatch = useDispatch()

//     const navigate = useNavigate()

//     const [filteredProjects, setFilteredProjects] = useState([])
//     const [filteredAssignees, setFilteredAssignees] = useState([])
//     const [value, setValue] = useState([])
//     const [values, setValues] = useState(initialValues)
//     console.log("🚀 ~ values:", values)
//     const [errors, setErrors] = useState(initialValues)
//     const [isSubmiting, setSubmiting] = useState(false)
//     const [isEditReport, setIsEditReport] = useState(false)
//     const [searchValue, setSearchValue] = useState('');

//     const pdfData = useSelector((state) => state.reportTimesheet)
//     const { projects, status } = useSelector(projectsState)
//     const { pageLimit, teamList } = useSelector(teamState)

//     const pdfReportData = pdfData?.pdfData
//     const pdfProjectData = pdfData?.pdfSelectedData

//     const formatDatePicker = (value) => {
//         return `${dayjs(value).format('DD MMM YY')}`
//     }
//     useEffect(() => {
//         if (!previewModal) return;

//         const projectExists = filteredProjects.some(p => p.value === selectedProject);
//         const assigneeOptions = selectAssignees?.map((selected) =>
//             filteredAssignees.find((a) => a.value === selected.value)
//         ).filter(Boolean); // remove any undefined if mismatch

//         setValues((prev) => ({
//             ...prev,
//             projects: projectExists ? selectedProject : '',
//             assignee: assigneeOptions || [],
//         }));

//         setValue(assigneeOptions || []);
//     }, [filteredProjects, filteredAssignees, selectedProject, selectAssignees, previewModal]);

//     useEffect(() => {
//         if (projects?.length > 0) {
//             let filterProjects = []

//             const projectsList = projects.map((data) => {
//                 return {
//                     label: data?.name,
//                     value: data?._id,
//                     projectProfile: data?.projectProfile,
//                 }
//             })
//             filterProjects = [...projectsList]

//             setFilteredProjects(filterProjects)
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [projects])

//     // CHECK FOR LAZY LOADING IS_NEXT
//     useEffect(() => {
//         if (teamList?.length > 0) {
//             let array = []
//             teamList?.length > 0 &&
//                 teamList.forEach((data) => {
//                     array = [
//                         ...array,
//                         {
//                             label: data?.name,
//                             value: data?._id,
//                         },
//                     ]
//                 })
//             let newArray = [...array]
//             let finalArray = unique(newArray, 'value')
//             setFilteredAssignees(finalArray)
//             // if (!isNext) {
//             //     return
//             // }
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [teamList])

//     useEffect(() => {
//         if (values?.projects !== '' && previewModal) {
//             dispatch(
//                 teamListGet({
//                     limit: pageLimit,
//                     skip: 0,
//                     projectId: values.projects,
//                 })
//             )
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [values.projects])

//     function updateDetails(name, value) {
//         setValues({
//             ...values,
//             [name]: value,
//         })
//         setErrors({ ...errors, [name]: '' })
//     }

//     async function onFinish() {
//         let projectName = filteredProjects?.filter(
//             (project) => project?.value === values?.projects
//         )

//         let assigneesId = values?.assignee?.map((v) => v.value)

//         setSubmiting(true)
//         let start = new Date(values?.start).setHours(0, 0, 0, 0)
//         let end = new Date(values?.end).setHours(23, 59, 59, 999)

//         const data = {
//             projectId: values?.projects,
//             start,
//             end,
//             assigneeId: assigneesId,
//         }

//         const reportRes = await timesheetApi(data)
//         if (reportRes?.data?.success) {
//             // navigate(PRIVATE_ROUTES.reportsPreview)
//             setSubmiting(false)
//             setIsEditReport(true)
//             dispatch(
//                 reportsActions.downloadPdfData({
//                     pdfData: reportRes?.data,
//                     pdfSelectedData: {
//                         assignees: values?.assignee,
//                         start,
//                         end,
//                         project: {
//                             id: values?.projects,
//                             name: projectName[0]?.label,
//                         },
//                     },
//                 })
//             )
//         } else {
//             setSubmiting(false)
//             setIsEditReport(false)
//             message.error(reportRes?.data?.message)
//         }
//     }

//     function onFinishFailed() { }

//     const onCloseModal = () => {
//         setValues(initialValues)
//         setIsEditReport(false)
//         onCancel()
//         dispatch(
//             reportsActions.downloadPdfData({
//                 pdfData: null,
//                 pdfSelectedData: null,
//             })
//         )
//     }
//     const debouncedFetchProject = useCallback(
//         debounce((value) => {
//             dispatch(
//                 projectsList({
//                     // skip: skipPage + pageLimit,
//                     // limit: pageLimit,
//                     search: value
//                 })
//             )
//         }, 600),
//         []
//     );

//     return (
//         <>
//             <Modal
//                 closable={false}
//                 open={previewModal}
//                 destroyOnClose={true}
//                 footer={null}
//                 onCancel={() => {
//                     onCloseModal()
//                 }}
//                 width={700}
//                 confirmLoading={loadingButton}
//                 title={
//                     <Row align={'middle'} style={{ columnGap: 10 }}>
//                         <Title level={4} style={{ margin: 0 }}>
//                             {modalTitle}
//                         </Title>
//                     </Row>
//                 }
//             >
//                 <Form
//                     layout="vertical"
//                     name="exportReports"
//                     onFinish={onFinish}
//                     onFinishFailed={onFinishFailed}
//                     requiredMark={false}
//                     labelCol={{
//                         style: {
//                             padding: '0 0 3px',
//                         },
//                     }}
//                 >
//                     <Row gutter={[16, 18]}>
//                         <Col span={24}>
//                             <Form.Item
//                                 label="Projects"
//                                 name="projects"
//                                 rules={[
//                                     {
//                                         required: true,
//                                         message: 'Please Select Project',
//                                     },
//                                 ]}
//                                 colon={false}
//                             >
//                                 <Select
//                                     placeholder="Select a Project"
//                                     onChange={(event) => {
//                                         setValue([])
//                                         setValues({ ...values, assignee: [] })
//                                         updateDetails('projects', event)
//                                     }}
//                                     showSearch
//                                     filterOption={(input, option) =>
//                                         option.label.toLowerCase().includes(input.toLowerCase())
//                                     }
//                                     notFoundContent={
//                                         status === "loading" ? (
//                                             <Spin size="small" />
//                                         ) : filteredProjects?.length === 0 ? (
//                                             'No projects found'
//                                         ) : null
//                                     }
//                                     onDropdownVisibleChange={(open) => {
//                                         if (open) {
//                                             debouncedFetchProject('');
//                                         } else {
//                                             setSearchValue('');
//                                         }
//                                     }}
//                                     allowClear={false}
//                                     showArrow={false}
//                                     options={filteredProjects}
//                                 >
//                                     {/* {filteredProjects?.length > 0 &&
//                                     filteredProjects.map((data) => (
//                                         <Option
//                                             value={data?.value}
//                                             key={data?.label}
//                                         >
//                                             {data?.label}
//                                         </Option>
//                                     ))} */}
//                                 </Select>
//                             </Form.Item>
//                         </Col>
//                         {values?.projects?.length > 0 && (
//                             <Col span={24}>
//                                 <Form.Item
//                                     label="Assignee"
//                                     name="assignee"
//                                     rules={[
//                                         {
//                                             required: true,
//                                             message: 'Please Select Assignee',
//                                         },
//                                     ]}
//                                     colon={false}
//                                 >
//                                     <Select
//                                         mode="multiple"
//                                         value={value}
//                                         defaultValue={value}
//                                         placeholder="Select Assignee..."
//                                         labelInValue
//                                         showSearch
//                                         showArrow={false}
//                                         filterOption={(input, option) =>
//                                             option.label.toLowerCase().includes(input.toLowerCase())
//                                         }

//                                         // options={filteredAssignees}
//                                         options={[
//                                             { label: 'All', value: 'all' },
//                                             ...filteredAssignees,
//                                         ]}
//                                         // onChange={(_, value) => {
//                                         //     setValue(value)
//                                         //     updateDetails('assignee', value)
//                                         // }}
//                                         onChange={(
//                                             selectedValues,
//                                             selectedOptions
//                                         ) => {
//                                             console.log(
//                                                 selectedValues,
//                                                 // selectedOptions,
//                                                 'abcdef'
//                                             )
//                                             const isSelectAll =
//                                                 selectedOptions.some(
//                                                     (option) =>
//                                                         option.value === 'all'
//                                                 )

//                                             if (isSelectAll) {
//                                                 const allIds =
//                                                     filteredAssignees.map(
//                                                         (assignee) => ({
//                                                             label: assignee.label,
//                                                             value: assignee.value,
//                                                         })
//                                                     )
//                                                 setValue(allIds)
//                                                 updateDetails(
//                                                     'assignee',
//                                                     allIds
//                                                 )
//                                             } else {
//                                                 setValue(selectedValues)
//                                                 updateDetails(
//                                                     'assignee',
//                                                     selectedValues
//                                                 )
//                                             }
//                                         }}
//                                         // style={{ height: 'auto !important' }}
//                                         style={{
//                                             width: '100%',
//                                             margin: 0,
//                                         }}
//                                         rootClassName={['p-0-multiSelect']}
//                                     />
//                                 </Form.Item>
//                             </Col>
//                         )}
//                         {values?.assignee?.length > 0 &&
//                             values?.projects?.length > 0 && (
//                                 <Col span={24}>
//                                     <Form.Item
//                                         label="Date Range"
//                                         colon={false}
//                                         name={'rangePicker'}
//                                         rules={[
//                                             {
//                                                 required: true,
//                                                 message:
//                                                     'Please Select Date Range',
//                                             },
//                                         ]}
//                                     >
//                                         <RangePicker
//                                             picker={'date'}
//                                             allowClear={false}
//                                             name={'rangePicker'}
//                                             format={formatDatePicker}
//                                             style={{ width: '100%' }}
//                                             onChange={(event) => {
//                                                 setValues({
//                                                     ...values,
//                                                     start: event[0],
//                                                     end: event[1],
//                                                 })
//                                             }}
//                                         />
//                                     </Form.Item>
//                                 </Col>
//                             )}
//                     </Row>
//                     <Row
//                         justify={'end'}
//                         style={{
//                             marginTop: 30,
//                             columnGap: 10,
//                         }}
//                     >
//                         <Button
//                             props={{
//                                 text: 'Cancel',
//                                 onClick: onCloseModal,
//                                 type: 'link',
//                                 style: {
//                                     color: token.colorPalette.baseColor.black,
//                                 },
//                             }}
//                         />
//                         {!pdfProjectData && !pdfReportData && (
//                             <Button
//                                 props={{
//                                     text: 'Next',
//                                     htmlType: 'submit',
//                                     loadingButton: isSubmiting,
//                                 }}
//                             />
//                         )}
//                     </Row>
//                 </Form>
//             </Modal>

//             <EditReport
//                 isEditReport={isEditReport}
//                 setIsEditReport={setIsEditReport}
//             />
//         </>
//     )
// }

// export default DownloadPopUp

import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    Col,
    Form,
    Modal,
    Row,
    Typography,
    Select,
    DatePicker,
    message,
    theme,
    Spin,
    Divider,
    Avatar,
} from 'antd'
import { timesheetApi } from './redux/apis'
import { reportsActions } from './redux/slice'
import { projectsList, projectsState } from '../../projects/projects.slice'
import { teamListGet, teamState } from '../../team/team.slice'
import Button from '../../../components/button/button'
import EditReport from './EditReport'
import { unique } from '../../../helpers/uniqueArray'
import dayjs from 'dayjs'
import { debounce } from 'lodash'
import { CrossIcon } from '../../../assets/icons'

const DownloadPopUp = ({
    previewModal,
    onCancel,
    modalTitle,
    loadingButton,
    selectedProject,
    selectAssignees,
}) => {
    const { Title } = Typography
    const { useToken } = theme
    const { token } = useToken()
    const { RangePicker } = DatePicker
    const [form] = Form.useForm()
    const dispatch = useDispatch()

    const initialValues = useMemo(
        () => ({
            projects: '',
            assignee: [],
            rangePicker: [],
            start: '',
            end: '',
        }),
        []
    )

    const [filteredProjects, setFilteredProjects] = useState([])
    const [filteredAssignees, setFilteredAssignees] = useState([])
    const [value, setValue] = useState([])
    const [values, setValues] = useState(initialValues)
    const [isSubmitting, setSubmitting] = useState(false)
    const [isEditReport, setIsEditReport] = useState(false)
    const formInitialized = useRef(false)
    const { projects, status } = useSelector(projectsState)
    const { pageLimit, teamList, downloadModalTeamList } = useSelector(teamState)
    const pdfData = useSelector((state) => state.reportTimesheet)
    const pdfReportData = pdfData?.pdfData
    const pdfProjectData = pdfData?.pdfSelectedData

    const formatDatePicker = (value) => dayjs(value).format('DD MMM YY')

    const updateDetails = (name, val) => {
        setValues((prev) => ({ ...prev, [name]: val }))
        form.setFieldsValue({ [name]: val })
    }

    const debouncedFetchProject = useCallback(
        debounce((val) => {
            dispatch(projectsList({ search: val, isDownloadModal: true }))
        }, 600),
        []
    )

    useEffect(() => {
        if (projects?.length > 0) {
            const projectOptions = projects.map((data) => ({
                label: data?.name,
                value: data?._id,
                projectProfile: data?.projectProfile,
            }))
            setFilteredProjects(projectOptions)
        }
    }, [projects])

    useEffect(() => {
        if (downloadModalTeamList?.length > 0) {
            const teamOptions = unique(
                downloadModalTeamList.map((data) => ({
                    label: data?.name,
                    value: data?._id,
                })),
                'value'
            )
            setFilteredAssignees(teamOptions)
        }
    }, [downloadModalTeamList])


    useEffect(() => {
        if (!previewModal || formInitialized.current) return

        const projectExists = filteredProjects.some(
            (p) => p.value === selectedProject
        )
        const assigneeOptions = selectAssignees
            ?.map((selected) =>
                filteredAssignees.find((a) => a.value === selected)
            )
            .filter(Boolean)

        const updated = {
            projects: projectExists ? selectedProject : null,
            assignee: assigneeOptions || [],
        }

        setValues((prev) => ({ ...prev, ...updated }))
        setValue(assigneeOptions || [])
        form.setFieldsValue(updated)

        formInitialized.current = true // only run once
    }, [
        filteredProjects,
        filteredAssignees,
        selectedProject,
        selectAssignees,
        previewModal,
    ])

    useEffect(() => {
        if (values?.projects && previewModal) {
            dispatch(
                teamListGet({
                    limit: pageLimit,
                    skip: 0,
                    projectId: values.projects,
                    isDownloadModal: true
                })
            )
        }
    }, [values.projects])

    useEffect(() => {
        // Clear date range when project or assignee changes to invalid state
        if (!values.projects || values.assignee?.length === 0) {
            setValues((prev) => ({
                ...prev,
                rangePicker: [],
                start: '',
                end: '',
            }))
            form.setFieldsValue({ rangePicker: [] })
        }
    }, [values.projects, values.assignee])

    const onCloseModal = () => {
        setValues(initialValues)
        setIsEditReport(false)
        onCancel()
        form.resetFields()
        formInitialized.current = false
        dispatch(
            reportsActions.downloadPdfData({
                pdfData: null,
                pdfSelectedData: null,
            })
        )
    }

    const onFinish = async () => {
        const selectedProjectData = filteredProjects.find(
            (p) => p.value === values.projects
        )
        const assigneesId = values.assignee.map((a) => a.value)
        const start = new Date(values.start).setHours(0, 0, 0, 0)
        const end = new Date(values.end).setHours(23, 59, 59, 999)

        const reqData = {
            projectId: values.projects,
            start,
            end,
            assigneeId: assigneesId,
        }

        setSubmitting(true)
        const reportRes = await timesheetApi(reqData)

        if (reportRes?.data?.success) {
            setIsEditReport(true)
            dispatch(
                reportsActions.downloadPdfData({
                    pdfData: reportRes.data,
                    pdfSelectedData: {
                        assignees: values.assignee,
                        start,
                        end,
                        project: {
                            id: values.projects,
                            name: selectedProjectData?.label,
                        },
                    },
                })
            )
        } else {
            message.error(reportRes?.data?.message)
            setIsEditReport(false)
        }
        setSubmitting(false)
    }

    const tagRender = (props) => {
        const { label, value, closable, onClose } = props

        const selectedUser = filteredAssignees.find(
            (user) => user.value === value
        )

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: '#f5f5f5',
                    borderRadius: 10,
                    padding: '4px 8px 4px 4px',
                    margin: '4px 2px',
                    maxWidth: '100%',
                    border: '1px solid #afafaf80',
                }}
            >
                {selectedUser?.profilePicture ? (
                    <Avatar
                        size={22}
                        src={selectedUser.profilePicture}
                        style={{ marginRight: 6 }}
                    />
                ) : (
                    <Avatar
                        size={22}
                        style={{
                            backgroundColor: 'rgb(0 10 129 / 25%)',
                            color: '#000',
                            fontSize: 10,
                            marginRight: 6,
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {selectedUser?.label?.[0]?.toUpperCase()}
                        {selectedUser?.label?.split(' ')[1]?.[0]?.toUpperCase()}
                    </Avatar>
                )}
                <span
                    style={{
                        fontSize: 12,
                        fontWeight: 500,
                        color: '#333',
                        marginRight: 4,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: 100,
                    }}
                >
                    {selectedUser?.label}
                </span>
                {closable && (
                    <span
                        onClick={onClose}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            marginLeft: '5px',
                        }}
                    >
                        <CrossIcon width={10} color={'#252525'} />
                    </span>
                )}
            </div>
        )
    }
    return (
        <>
            <Modal
                closable={true}
                open={previewModal}
                destroyOnClose
                footer={
                    <>
                        <Divider style={{ margin: "5px 0px 0px" }} />
                        <Row
                            justify="end"
                            style={{
                                marginTop: 15,
                                columnGap: 10,
                                padding: '0px 20px 18px',
                            }}
                        >
                            <Button
                                props={{
                                    text: 'Cancel',
                                    onClick: onCloseModal,
                                    type: 'link',
                                    style: { color: token.colorText },
                                }}
                            />
                            {!pdfProjectData && !pdfReportData && (
                                <Button
                                    props={{
                                        text: 'Next',
                                        // htmlType: 'submit',
                                        onClick: () => form.submit(),
                                        loadingButton: isSubmitting,
                                    }}
                                />
                            )}
                        </Row>
                    </>
                }
                width={700}
                title={
                    <>
                        <div style={{ padding: '18px 20px 0px' }}>
                            <Row
                                align="middle"
                                justify="start"
                                style={{ columnGap: '10px' }}
                            >
                                <Title
                                    level={4}
                                    style={{ margin: 0, fontWeight: '700' }}
                                >
                                    {modalTitle}
                                </Title>
                            </Row>
                            <Row
                                align="middle"
                                justify="start"
                                style={{ marginTop: '5px' }}
                            >
                                <Title
                                    style={{
                                        margin: 0,
                                        fontSize: '14px',
                                        color: '#7c7c7c',
                                    }}
                                >
                                    Select a project, choose assignees, and
                                    export work logs.
                                </Title>
                            </Row>
                        </div>
                        <Divider style={{ margin: '0px', marginTop: '10px' }} />
                    </>
                }
                // title={<Title level={4}>{modalTitle}</Title>}
                onCancel={onCloseModal}
                styles={{ content: { padding: '0px' } }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    requiredMark={false}
                >
                    <Row gutter={[16, 18]} style={{ padding: '  0px 20px' }}>
                        <Col span={24}>
                            <Form.Item
                                label="Projects"
                                name="projects"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Project',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select a Project"
                                    showSearch
                                    options={filteredProjects}
                                    notFoundContent={
                                        status === 'loading' ? (
                                            <Spin size="small" />
                                        ) : (
                                            'No projects found'
                                        )
                                    }
                                    filterOption={(input, option) =>
                                        option.label
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    onChange={(val) => {
                                        setValue([])
                                        updateDetails('projects', val)
                                        updateDetails('assignee', [])
                                    }}
                                    onDropdownVisibleChange={(open) =>
                                        open && debouncedFetchProject('')
                                    }
                                />
                            </Form.Item>
                        </Col>

                        {!!values.projects && (
                            <Col span={24}>
                                <Form.Item
                                    label="Assignee"
                                    name="assignee"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please Select Assignee',
                                        },
                                    ]}
                                >
                                    <Select
                                        mode="multiple"
                                        labelInValue
                                        value={value}
                                        placeholder="Select Assignee..."
                                        options={[
                                            { label: 'All', value: 'all' },
                                            ...filteredAssignees,
                                        ]}
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.label
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                        tagRender={tagRender}
                                        onChange={(
                                            selectedValues,
                                            selectedOptions
                                        ) => {
                                            const isAll = selectedOptions.some(
                                                (opt) => opt.value === 'all'
                                            )
                                            const selected = isAll
                                                ? filteredAssignees.map(
                                                    (a) => ({
                                                        label: a.label,
                                                        value: a.value,
                                                    })
                                                )
                                                : selectedValues
                                            setValue(selected)
                                            updateDetails('assignee', selected)
                                        }}
                                        rootClassName="p-0-multiSelect"
                                        className="add_member_model"
                                    />
                                </Form.Item>
                            </Col>
                        )}

                        {!!values.projects && !!values.assignee.length && (
                            <Col span={24}>
                                <Form.Item
                                    label="Date Range"
                                    name="rangePicker"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please Select Date Range',
                                        },
                                    ]}
                                >
                                    <RangePicker
                                        format={formatDatePicker}
                                        allowClear={false}
                                        onChange={(dates) => {
                                            updateDetails('start', dates?.[0])
                                            updateDetails('end', dates?.[1])
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        )}
                    </Row>
                </Form>
            </Modal>

            {/* <EditReport
                isEditReport={isEditReport}
                setIsEditReport={setIsEditReport}
            /> */}
        </>
    )
}

export default DownloadPopUp
